import React from 'react';
import { Container, Typography, Card, CardContent, Grid, Box, Chip } from '@mui/material';

const ClinicalProfile = ({ user, accessLevel }) => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Clinical Profile
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Manage your mCODE clinical profile, treatment history, and health information.
      </Typography>

      <Grid container spacing={3}>
        {/* Primary Cancer Condition */}
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Primary Cancer Condition
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
                <Chip label="Breast Cancer" color="primary" />
                <Chip label="Stage IIIA" color="secondary" />
                <Chip label="ER+" variant="outlined" />
                <Chip label="PR+" variant="outlined" />
                <Chip label="HER2-" variant="outlined" />
              </Box>
              <Typography variant="body2" color="text.secondary">
                Diagnosed: March 2024 | TNM Staging: T2N1M0
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Treatment History */}
        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Treatment History
              </Typography>
              <Typography variant="body2" color="text.secondary">
                • Neoadjuvant chemotherapy (AC-T regimen) - Completed
                <br />
                • Lumpectomy with sentinel lymph node biopsy - April 2024
                <br />
                • Radiation therapy - In progress
                <br />
                • Hormone therapy (Tamoxifen) - Planned
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Genomic Variants */}
        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Genomic Profile
              </Typography>
              <Typography variant="body2" color="text.secondary">
                • BRCA1/2: Negative
                <br />
                • MSI Status: MSS
                <br />
                • TMB: 5 mutations/Mb
                <br />
                • PD-L1 Expression: 15%
                <br />
                • PIK3CA: Wild-type
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Performance Status */}
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Performance Status & Eligibility
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <Typography variant="subtitle2">ECOG Performance Status</Typography>
                  <Typography variant="h5" color="success.main">0</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Fully active, able to carry on all pre-disease performance
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="subtitle2">Karnofsky Score</Typography>
                  <Typography variant="h5" color="success.main">100%</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Normal activity, no evidence of disease
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography variant="subtitle2">Trial Eligibility</Typography>
                  <Chip label="Eligible for 12 trials" color="success" />
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    Based on current clinical profile
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ClinicalProfile;